"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _react = require("react");

var _scriptjs = _interopRequireDefault(require("scriptjs"));

var useScriptLoad = function useScriptLoad(_ref) {
  var url = _ref.url;

  var _useState = (0, _react.useState)({
    scriptLoaded: false
  }),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  (0, _react.useEffect)(function () {
    (0, _scriptjs.default)(url, function () {
      return setState({
        scriptLoaded: true
      });
    });
  }, []);
  return state.scriptLoaded ? true : false;
};

var _default = useScriptLoad;
exports.default = _default;